// extracted by mini-css-extract-plugin
module.exports = {"richText":"RichText_richText__8IUJ0"};
module.exports.__checksum = "cfae62d1f152"
